export default __webpack_public_path__ + "static/media/ada.60771954.png";